import { InputLabel, Select, Stack, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import StockWrapper from "../StockWrapper";
import { connect } from "react-redux";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";

import {
  djangoHandleDataMutationRequest,
  djangoHandleDataRequests,
  handleSpringDataRequest,
} from "../../../api";
import { toast } from "material-react-toastify";
import ReportsLoader from "../../../Utils/ReportsLoader";
import { Divider, FormControl, MenuItem, Typography } from "@material-ui/core";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";
import { useTranslation } from "react-i18next";

function WarehouseCumulativeReport({ data }) {
  const { t } = useTranslation();

  const hotelCurrency = data?.accessControl?.hotel?.hotel_currency;

  const { ExportCSVButton } = CSVExport;
  const { SearchBar } = Search;

  const url = new URL(window.location.href);
  const hotelId = url.searchParams.get("hotelId");
  //columns of table
  const [rowsdats, setrowsdats] = useState(null);
  const [reportsColumns, setreportsColumns] = useState([]);

  // Get All report data
  const [reportsData, setreportsData] = useState([]);
  const [supplier, setsupplier] = useState("");

  // Getting the start date as well as the end date to load the data
  const [dateVal, setDateVal] = useState(dayjs(new Date()));
  const handleChange = (newVal) => {
    setDateVal(newVal);
  };

  const [outletType, setoutletType] = useState("single");

  function handleGetAllKitchenConfig() {
    handleSpringDataRequest("core/api/v1/kitchen/get-all")
      .then((res) => {
        if (res?.length <= 1) {
          setoutletType("single");
        } else {
          setoutletType("multi");
        }
      })
      .catch((err) => console.log(err));
  }
  useEffect(() => {
    handleGetAllKitchenConfig();
  }, []);

  //Function to get report data
  const getAllRestaurantReportData = () => {
    setrowsdats(null);
    djangoHandleDataMutationRequest("POST", `pos/cumulative-warehouse/`, {
      hotel_id: hotelId,
      today_start_date: moment(new Date(dateVal)).format("YYYY-MM-DD 00:00:00"),
      today_end_date: moment(new Date(dateVal)).format("YYYY-MM-DD 23:59:59"),
      prev_start_date: moment(new Date(dateVal))
        .subtract(1, "days")
        .format("YYYY-MM-DD 00:00:00"),
      prev_end_date: moment(new Date(dateVal))
        .subtract(1, "days")
        .format("YYYY-MM-DD 23:59:59"),
      outlet_type: outletType,
    })
      .then((res) => {
        setreportsData(res);
        setrowsdats(res);
      })
      .catch((err) =>
        toast.error(`${t("Error in getting  data! Please try again later.")}`)
      );
  };

  useEffect(() => {
    getAllRestaurantReportData();
  }, [dateVal, outletType]);

  //Rows data generator
  const productsGenerator = (quantity, data) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        id: data[i].id,
        name: data[i].name,
        category: data[i].category,
        opening_stock:
          data[i].opening_stock === 0 ? 0 : data[i].opening_stock.toFixed(2),
        purchase_qty:
          data[i].purchase_qty === 0 ? 0 : data[i].purchase_qty.toFixed(2),
        excess_rm: data[i].excess_rm === 0 ? 0 : data[i].excess_rm.toFixed(2),
        total_stock:
          data[i].total_stock === 0 ? 0 : data[i].total_stock.toFixed(2),
        consumption:
          data[i].consumption === 0 ? 0 : data[i].consumption.toFixed(2),
        wastage_qty:
          data[i].wastage_qty === 0 ? 0 : data[i].wastage_qty.toFixed(2),
        normal_loss:
          data[i].normal_loss === 0 ? 0 : data[i].normal_loss.toFixed(2),
        shortage_rm:
          data[i].shortage_rm === 0 ? 0 : data[i].shortage_rm.toFixed(2),
        total_consumption: data[i].total_consumption.toFixed(2),
        net_stock: data[i].net_stock.toFixed(2),
        stock_unit: data[i].stock_unit,
        outlet: data[i].outlet,
      });
    }
    return items;
  };

  const headerStyle = {
    width: "150px",
  };

  // Report columns
  const columns = [
    {
      dataField: "id",
      text: `${t("Id")}`,
      sort: true,
      hidden: true,
    },
    {
      dataField: "name",
      text: `${t("Raw Material Name")}`,
      sort: true,
      headerStyle: headerStyle,
    },
    {
      dataField: "category",
      text: `${t("Category")}`,
      sort: true,
    },
    {
      dataField: "opening_stock",
      text: `${t("Opening Stock (A)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "purchase_qty",
      text: `${t("Purchase Quantity (B)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "excess_rm",
      text: `${t("Excess Raw Material (C)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "total_stock",
      text: `${t("Total Stock (A+B+C)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "consumption",
      text: `${t("Consumption (D)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "wastage_qty",
      text: `${t("Wastage Quantity (E)")}`,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "normal_loss",
      text: `${t("Normal Loss (F)")}`,
      sort: true,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "shortage_rm",
      text: `${t("Shortage Raw Material (G)")}`,
      sort: true,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "total_consumption",
      text: `${t("Total Consumption (D+E+F+G)")}`,
      sort: true,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "net_stock",
      text: `${t("Net Stock (A+B+C-D-E-F-G)")}`,
      sort: true,
      formatter: (cell) => {
        return Number(Math.abs(cell)).toFixed(2);
      },
    },
    {
      dataField: "stock_unit",
      text: `${t("Stock Unit")}`,
      sort: true,
    },
    {
      dataField: "outlet",
      text: `${t("Outlet")}`,
    },
  ];

  useEffect(() => {
    const names = [
      "Id",
      "Name",
      "Category",
      "Opening Stock (A)",
      `Purchase Quantity (B)`,
      `Excess Raw Material (C)`,
      `Total Stock (A+B+C)`,
      `Consumption (D)`,
      `Wastage Quantity (E)`,
      `Normal Loss (F)`,
      `Shortage Raw Material (G)`,
      `Total Consumption (D+E+F+G)`,
      `Net Stock (A+B+C-D-E-F-G)`,
      `Stock Unit`,
      "Outlet",
    ];
    if (reportsData?.length > 0) {
      let arr = [];
      const array = Object.keys(reportsData[0]);
      for (var i = 0; i < array?.length; i++) {
        arr.push({
          dataField: array[i],
          text: names[i],
          sort: true,
          hidden: names[i] === "Id" ? true : false,
        });
      }

      setreportsColumns(arr);
    }
  }, [reportsData]);
  return (
    <>
      <StockWrapper
        backBtn={true}
        hideDrawer={true}
        stockTypeName={t("Warehouse cumulative stock report")}
        contentArea={
          <Stack className="position-relative mt-8">
            <>
              {rowsdats ? (
                <div className="App">
                  {/* {reportsColumns.length > 0 && ( */}
                  <ToolkitProvider
                    keyField="id"
                    data={rowsdats}
                    columns={columns}
                    exportCSV
                    search
                  >
                    {(props) => (
                      <div>
                        <Stack
                          className="position-relative w-100 justify-content-between mt-8"
                          direction={"row"}
                        >
                          <Stack
                            className="position-relative"
                            direction="row"
                            spacing={2}
                          >
                            <SearchBar
                              {...props.searchProps}
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            />
                            <Stack
                              spacing={4}
                              className="position-relative"
                              style={{ width: "fit-content" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                  label={t("Select date")}
                                  inputFormat="DD/MM/YYYY"
                                  //inputFormat="dd MMM yyyy"
                                  value={dateVal}
                                  onChange={handleChange}
                                  renderInput={(params) => (
                                    <TextField {...params} size="small" />
                                  )}
                                />
                              </LocalizationProvider>
                            </Stack>
                          </Stack>

                          <ExportCSVButton
                            {...props.csvProps}
                            style={{
                              display: "block",
                              background: "black",
                              color: "white",
                              marginTop: -1.5,
                              marginBottom: "auto",
                              marginLeft: "auto",
                            }}
                          >
                            {t("Export CSV")}
                          </ExportCSVButton>
                        </Stack>
                        <Stack className="position-relativre mt-8">
                          {columns.length > 0 && rowsdats.length > 0 ? (
                            <BootstrapTable
                              pagination={paginationFactory({
                                sizePerPage: 10,
                              })}
                              {...props.baseProps}
                            />
                          ) : (
                            <Typography
                              className="position-relative mt-8 text-align-center"
                              style={{
                                fontSize: "15px",
                                marginTop: "15px",
                                color: "grey",
                                textAlign: "center",
                              }}
                            >
                              {t("No data found!")}
                            </Typography>
                          )}
                        </Stack>
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              ) : (
                <ReportsLoader />
              )}
            </>
          </Stack>
        }
      />
    </>
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(WarehouseCumulativeReport);
